<div class="card">
    <div class="card-header">
        Manpower Recall
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site'); ComboLoad('Designation')">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Designation</label>
                <ng-select name="designation" [items]="DesignationLoad" bindLabel="DesignationName"
                    [(ngModel)]="DesignationId" (change)=" onSelectChange('Designation'); ComboLoad('Duty')"
                    bindValue="DesignationMasterID">
                    <ng-option *ngFor="let segment of DesignationLoad" [value]="segment.DesignationMasterID">
                        {{ segment.DesignationName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Duty</label>
                <ng-select name="dutyname" [items]="DutyLoad" [(ngModel)]="DutyId" (change)="onSelectChange('Duty')"
                    bindLabel="DutyName" bindValue="DutyMasterID">
                    <ng-option *ngFor="let segment of DutyLoad" [value]="segment.DutyMasterID">
                        {{ segment.DutyName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Shift</label>
                <ng-select name="Shift" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                    [(ngModel)]="ShiftID" (change)="onSelectChange('Shift')">
                    <ng-option *ngFor="let segment of Shift" [value]="segment.ShiftMasterID">
                        {{ segment.ShiftTitle }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Work Order No.</label>
                <input name="workorderno" [(ngModel)]="WorkOrderNumber" type="text" class="form-control" />
            </div>
            <div class="col-md-2 px-1"><br>
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Load()">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="card-body p-1" style="overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">
                            <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px;" name="header"
                                type="checkbox" (change)="toggleSelectAllRows()" [checked]="selectAllRows" value="" />
                        </th>
                        <th scope="col" style="display: none;">EntryNo</th>
                        <th scope="col" style="display: none;">ESS_ShiftWiseManpowerMasterId</th>
                        <th scope="col">WONo</th>
                        <th scope="col">WODate</th>
                        <th scope="col" style="display: none;">Branch Id</th>
                        <th scope="col">Branch Name</th>
                        <th scope="col" style="display: none;">Client Id</th>
                        <th scope="col">ClientGroup Name</th>
                        <th scope="col" style="display: none;">Site Id</th>
                        <th scope="col">Site</th>

                        <th scope="col" style="display: none;">Designation Id </th>
                        <th scope="col">Designation</th>
                        <th scope="col" style="display: none;">Duty ID</th>
                        <th scope="col">Duty</th>
                        <th scope="col" style="display: none;">Shift ID</th>
                        <th scope="col">Shift</th>
                        <th scope="col">Allocation Type</th>

                        <th scope="col">From Date </th>
                        <th scope="col">To Date</th>
                        <th scope="col">No Of Person</th>
                        <th scope="col" style="display: none;">Attachment</th>
                        <th scope="col">Remarks</th>
                        <th scope="col" style="display: none;">RefESS_ShiftWiseManpowerDetailsId</th>
                        <th scope="col">Balance</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of RecallData; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>
                            <input mdbCheckbox class="form-check-input" name="row" style="height: 13px; width: 13px;"
                                type="checkbox" [(ngModel)]="site.checked" (change)="toggleRowEnabled(i)" value="" />
                        </td>
                        <td style="display: none;">{{ site['EntryNo'] }}</td>
                        <td style="display: none;">{{ site['ESS_ShiftWiseManpowerMasterId'] }}</td>
                        <td>{{ site['WONo'] }}</td>
                        <td>{{ site['WODate'] }}</td>
                        <td style="display: none;">{{ site['BranchId'] }}</td>
                        <td>{{ site['BranchName'] }}</td>
                        <td style="display: none;">{{ site['ClientId'] }}</td>
                        <td>{{ site['ClientGroupName'] }}</td>
                        <td style="display: none;">{{ site['SiteId'] }}</td>
                        <td>{{ site['SiteName'] }}</td>
                        <td style="display: none;">{{ site['DesignationId'] }}</td>
                        <td>{{ site['DesignationName'] }}</td>
                        <td style="display: none;">{{ site['DutyId'] }}</td>
                        <td>{{ site['DutyName'] }}</td>
                        <td style="display: none;">{{ site['ShiftId'] }}</td>
                        <td>{{ site['ShiftTitle'] }}</td>
                        <td>{{ site['AllocationType'] }}</td>
                        <td>{{ site['FromDate'] }}</td>
                        <td>{{ site['ToDate'] }}</td>
                        <td>{{ site['NoOfPerson'] }}</td>
                        <td style="display: none;">{{ site['Attachment'] }}</td>
                        <td>{{ site['Remarks'] }}</td>
                        <td style="display: none;">{{ site['RefESS_ShiftWiseManpowerDetailsId'] }}</td>

                        <td>{{ site['Balance'] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                    name="save" (click)="Save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>